<template>
    <div>
        <!--<el-button type="warning" size="small" icon="el-icon-heavy-rain" @click="produce">生成云矿</el-button>-->
        <common-table :table-columns="tableColumns"
                      :form-fields="{model: []}"
                      :url="url" :permission="{}"
                      :operate="operate"
                      :searchs="searchs"
                      :buttons="buttons"
                      ref="table"/>
        <!--代理选择框-->
        <div class="dialog">
            <el-dialog title="选择代理"
                       :visible.sync="agentVisible"
                       custom-class="common-dialog"
                       :close-on-click-modal="false"
                       @close="resetForm"
                       width="30%">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon label-width="60px"
                             :model="form" ref="form">
                        <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: true}]">
                            <el-select size="medium"
                                       v-model="form.agentId"
                                       placeholder="请选择代理"
                                       clearable
                                       :filterable="true">
                                <el-option v-for="(option, index) in agentList"
                                           :key="index"
                                           :label="option.username"
                                           :value="option.id"/>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="agentVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="submit">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import CommonTable from "../../components/CommonTable/CommonTable";
    export default {
        name: "CloudMining",
        components: {CommonTable},
        data() {
            return {
                type: 0,// type 为 1 是成功云矿，为 2 是一键结算云矿
                agentVisible: false,
                form: {
                    agentId: null,
                },
                agentList: [],
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }, {
                    name: 'phone',
                    placeholder: '用户',
                    type: 'input'
                }, {
                    name: 'status',
                    placeholder: '请选择状态',
                    type: 'select',
                    selectValue:[{
                        key: 0,
                        value: '未结算'
                    },{
                        key: 1,
                        value: '已结算'
                    }]
                }, {
                    name: 'startTime',
                    placeholder: '开始时间',
                    type: 'dateTime'
                }, {
                    name: 'endTime',
                    placeholder: '结束时间',
                    type: 'dateTime'
                }],
                url: {
                    get: '/cloudMining/listByCondition',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select',
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'phone',
                    label: '用户',
                    show: true,
                    width: '',
                }, {
                    field: 'money',
                    label: '金额(USDT)',
                    show: true,
                    width: '',
                }, {
                    field: 'ratio',
                    label: '佣金比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    detail: false,
                    width: '',
                }, {
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags: [{
                            key: 1,
                            value: '已结算',
                            type: 'success'
                        }, {
                            key: 0,
                            value: '未结算',
                            type: 'warning'
                        }]
                    },
                    width: '',
                }, {
                  field: 'current',
                  label: '货币',
                  show: true,
                  detail: false,
                  width: '',
                }, {
                  field: 'site',
                  label: '购买平台',
                  show: true,
                  detail: false,
                  width: '',
                }, {
                  field: 'saleSite',
                  label: '销售平台',
                  show: true,
                  detail: false,
                  width: '',
                }, {
                  field: 'payAmount',
                  label: '买入价',
                  show: true,
                  detail: false,
                  width: '',
                }, {
                    field: 'createTime',
                    label: '创建时间',
                    show: true,
                    width: '',
                }],
                operate: [{
                    icon: 'el-icon-lightning',
                    type: 'text',
                    text: '结算',
                    title: '确定结算该用户云矿吗？',
                    handle: (row) => {
                        this.$axios.post({
                            url: '/cloudMining/settle/' + row.id,
                            loading: true,
                            success: (res) => {
                                if (res.code === 0) {
                                    row.status = 1;
                                    this.$message.success("Settled successfully");
                                    return;
                                }
                                this.$message.error(res.msg);
                            }
                        })
                    }
                }],
                buttons: [{
                    icon: 'el-icon-heavy-rain',
                    type: 'primary',
                    text: '生成云矿',
                    permission: 'cloudMining:produce',
                    click: () => {
                        this.getAgentList(1);
                    }
                }, {
                    icon: 'el-icon-cloudy-and-sunny',
                    type: 'warning',
                    text: '一键结算',
                    permission: 'cloudMining:allSettle',
                    click: () => {
                        this.getAgentList(2);
                    }
                }]
            }
        },
        methods: {
            getAgentList(type) {
                this.type = type;
                this.$axios.post({
                    url: '/agent/getAll',
                    loading: false,
                    success: (res) => {
                        if (res.code === 0) {
                            this.agentList = res.data;
                            if (res.data.length && res.data.length === 1) {
                                this.form.agentId = res.data[0].id;
                                this.submit();
                                return;
                            }
                            this.agentVisible = true;
                        }
                    }
                })
            },
            produce() {
                if (this.form.agentId) {
                    this.$axios.post({
                        url: '/cloudMining/produce/' + this.form.agentId,
                        loading: true,
                        confirm: '确定生成云矿吗？',
                        success: (res) => {
                            if (res.code === 0) {
                                this.$refs.table.getData();
                                this.$message.success("Cloud mining has been generated");
                                this.type = 0;
                                this.agentVisible = false;
                                return;
                            }
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            allSettle() {
                if (this.form.agentId) {
                    this.$axios.post({
                        url: '/cloudMining/allSettle/' + this.form.agentId,
                        loading: true,
                        confirm: '确定一键结算吗？',
                        success: (res) => {
                            if (res.code === 0) {
                                this.$refs.table.getData();
                                this.$message.success("One-click settlement has been successful");
                                this.type = 0;
                                this.agentVisible = false;
                                return;
                            }
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            submit() {
                if (this.type === 1) {
                    this.produce();
                } else if (this.type === 2) {
                    this.allSettle();
                }
            },
            //重置表单
            resetForm(){
                this.form.agentId = null;
            },
        }
    }
</script>

<style scoped>

</style>
